<template>
    <div class="push-guide position-relative overflow-hidden">
        <img class="push-guide__corner position-absolute top-0 end-0" src="/img/svg/nav-corner-1.svg" alt="">

        <section class="push-guide__hero container position-relative text-center">
            <p class="push-guide__eyebrow mb-3">{{$t('marketing.push_notifications.eyebrow')}}</p>
            <h1 id="push-guide-title" class="display-5 fw-bolder text-gray-900 mx-auto mb-3">
                {{$t('marketing.push_notifications.title')}}
            </h1>
            <p class="push-guide__subtitle fs-5 text-gray-600 mx-auto mb-3">
                {{$t('marketing.push_notifications.subtitle')}}
            </p>
            <router-link
            :to="{ name: 'push_notifications_android' }"
            class="push-guide__platform-link d-inline-flex align-items-center gap-2 mb-3"
            >
                {{$t('marketing.push_notifications.other_guide')}}
                <BootstrapIcon name="arrow-right" :size="15" aria-hidden="true" />
            </router-link>
            <p class="push-guide__screenshot-note small text-gray-500 mx-auto mb-0">
                {{$t('marketing.push_notifications.screenshot_note')}}
            </p>

            <aside class="push-guide__notice d-flex align-items-start gap-3 mx-auto text-start">
                <span class="push-guide__notice-icon flex-shrink-0" aria-hidden="true">
                    <BootstrapIcon name="info-circle" :size="20" />
                </span>
                <div>
                    <h2 class="h6 fw-bolder text-gray-900 mb-1">{{$t('marketing.push_notifications.before_title')}}</h2>
                    <p class="text-gray-600 mb-0">
                        {{$t('marketing.push_notifications.before_description_prefix')}}<a
                        class="fw-bolder text-teal-700"
                        :href="'https://store.' + TLD"
                        target="_blank"
                        rel="noopener"
                        >Tapgiant Delivery</a>{{$t('marketing.push_notifications.before_description_suffix')}}
                    </p>
                </div>
            </aside>
        </section>

        <section class="push-guide__instructions container" :aria-labelledby="'push-guide-title'">
            <ol class="push-guide__steps">
                <li v-for="(step, index) in steps" :key="step.image" class="push-guide__step bg-white">
                    <header class="push-guide__step-header d-flex align-items-start gap-3">
                        <span class="push-guide__step-number flex-shrink-0">{{index + 1}}</span>
                        <div>
                            <p class="push-guide__step-label mb-1">
                                {{$t('marketing.push_notifications.step_label', { CURRENT: index + 1, TOTAL: steps.length })}}
                            </p>
                            <h2 class="h4 fw-bolder text-gray-900 mb-2">{{step.title}}</h2>
                            <p class="text-gray-600 mb-0">{{step.description}}</p>
                        </div>
                    </header>
                    <figure class="push-guide__figure mb-0">
                        <img
                        class="push-guide__image d-block"
                        :src="step.image"
                        :alt="step.alt"
                        width="589"
                        height="1280"
                        :loading="index === 0 ? 'eager' : 'lazy'"
                        decoding="async"
                        >
                    </figure>
                </li>
            </ol>
        </section>

        <section class="push-guide__complete container text-center">
            <div class="push-guide__complete-card mx-auto">
                <span class="push-guide__complete-icon d-inline-flex align-items-center justify-content-center" aria-hidden="true">
                    <BootstrapIcon name="bell-fill" :size="24" />
                </span>
                <h2 class="h3 fw-bolder text-gray-900 mt-3 mb-2">{{$t('marketing.push_notifications.complete_title')}}</h2>
                <p class="text-gray-600 mx-auto mb-0">{{$t('marketing.push_notifications.complete_description')}}</p>
            </div>
        </section>
    </div>
</template>

<script>
import BootstrapIcon from '@/common/directive/BootstrapIcon'
import { TLD } from '@/common/constants.js'

export default {
    components: { BootstrapIcon },
    data: function () {
        return { TLD }
    },
    computed: {
        steps: function () {
            return [
                'web-push-screen-1-unavailable.jpeg',
                'web-push-screen-2-share.jpeg',
                'web-push-screen-3-view-more.jpeg',
                'web-push-screen-4-ready.jpeg',
                'web-push-screen-5-activated.jpeg'
            ].map((image, index) => ({
                image: `/img/webpush/${image}`,
                title: this.$t(`marketing.push_notifications.steps.${index + 1}.title`),
                description: this.$t(`marketing.push_notifications.steps.${index + 1}.description`),
                alt: this.$t(`marketing.push_notifications.steps.${index + 1}.alt`)
            }))
        }
    }
}
</script>
